import { Controller } from "@hotwired/stimulus"
import AutoNumeric from "autonumeric"

// Prefills payment amount as tokens × selected service group's token_price.
export default class extends Controller {
  static targets = ["tokens", "amount", "serviceGroup", "unitPriceHint"]
  static values = {
    unitPrice: Number,
    prices: { type: Object, default: {} }
  }

  connect() {
    this.syncUnitPriceFromGroup()
  }

  groupChanged() {
    this.syncUnitPriceFromGroup()
    this.recalculate()
  }

  recalculate() {
    if (!this.hasTokensTarget || !this.hasAmountTarget) return

    const tokens = Number.parseFloat(this.tokensTarget.value)
    if (!Number.isFinite(tokens) || tokens <= 0) return

    const total = Math.round(tokens * this.unitPriceValue)
    const autoNumeric = AutoNumeric.getAutoNumericElement(this.amountTarget)
    if (autoNumeric) {
      autoNumeric.set(total)
    } else {
      this.amountTarget.value = total
    }
  }

  syncUnitPriceFromGroup() {
    if (this.hasServiceGroupTarget) {
      const groupId = this.serviceGroupTarget.value
      const price = Number(this.pricesValue[groupId])
      this.unitPriceValue = Number.isFinite(price) ? price : 0
    }

    if (!this.hasUnitPriceHintTarget) return

    this.unitPriceHintTarget.hidden = this.unitPriceValue <= 0
    if (this.unitPriceValue > 0) {
      this.unitPriceHintTarget.textContent = this.unitPriceHintTarget.dataset.template.replace(
        "%{price}",
        this.formatClp(this.unitPriceValue)
      )
    }
  }

  formatClp(amount) {
    return new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
      maximumFractionDigits: 0
    }).format(amount)
  }
}
